import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@mkikets/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import axios from "axios";
import { Link } from "react-router-dom";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddContest from "../partials/AddContest";
import { toast, ToastContainer } from "react-toastify";
import Moment from "moment";
import * as myConstList from "../../actions/baseUrl";
import { DateRange } from "react-date-range";
import { addDays } from "date-fns";
import { format } from "date-fns";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const baseUrl = myConstList.baseUrl;
class SellOrder extends Component {
  constructor(props) {
    super(props);

    this.columns = [
      {
        text: "#",
        className: "id",
        align: "left",
        sortable: true,
        cell: (row, index) => index + 1,
      },
      {
        key: "id",
        text: "Sno",
        className: "user_id",
        align: "left",
        sortable: true,
      },
      {
        key: "email",
        text: "Email",
        className: "email",
        align: "left",
        sortable: true,
      },
      // {
      //   key: "mobile_no",
      //   text: "Mobile No.",
      //   className: "email",
      //   align: "left",
      //   sortable: true,
      // },
      {
        key: "per_price",
        text: "Sell Price",
        className: "amount",
        align: "left",
        sortable: true,
      },
      {
        key: "total_sell_spend_amount",
        text: "Amount (QTY)",
        className: "price",
        align: "left",
        sortable: true,
      },
      {
        key: "sell_get_amount",
        text: "Total (AMT)",
        className: "amount",
        align: "left",
        sortable: true,
      },

      {
        key: "sell_fees",
        text: "Sell Fees",
        className: "amount",
        align: "left",
        sortable: true,
      },

      {
        key: "pairname",
        text: "Pair",
        className: "stopLoss",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{record.pairname}</Fragment>;
        },
      },
      {
        key: "status",
        text: "Status",
        className: "status",
        align: "left",
        sortable: true,
      },
      {
        key: "created",
        text: "date",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return <Fragment>{Moment(record.created).format("lll")}</Fragment>;
        },
      },
      {
        key: "created",
        text: "Action",
        className: "date",
        align: "left",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              {(record.status == "pending") ?
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => this.deleteRecordMgs(record)}
                >
                  <i className="fa fa-times"></i>
                </button> : ""}
            </Fragment>
          );
        },
      },
    ];

    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      filename: "SellOrder List",
      no_data_text: "No user found!",
      button: {
        print: true,
        csv: true,
      },
      language: {
        length_menu: "Show _MENU_ result per page",
        filter: "Filter in records...",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        pagination: {
          first: "First",
          previous: "Previous",
          next: "Next",
          last: "Last",
        },
      },
      show_length_menu: true,
      show_filter: true,
      show_pagination: true,
      show_info: true,
    };

    const { firstcoin, secondcoin } = this.props.match.params;

    console.log("THISPARAMS", firstcoin, secondcoin);

    this.state = {
      records: [],
      openActivityDateRange: false,
      activityDateRange: [

      ],
      firstCoin: (firstcoin) ? firstcoin : "",
      secondCoin: (secondcoin) ? secondcoin : ""
    };



    this.getData = this.getData.bind(this);
  }
  handleSelect(ranges) {
    console.log(ranges);
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
  }
  componentDidMount() {
    // if (
    //   this.props.auth.user.sellOrder !== undefined &&
    //   this.props.auth.user.sellOrder !== 1
    // ) {
    //   this.props.history.push("/dashboard");
    // }
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    // if (
    //   nextProps.auth.user.sellOrder !== undefined &&
    //   nextProps.auth.user.sellOrder !== 1
    // ) {
    //   this.props.history.push("/dashboard");
    // }
    this.getData();
  }

  getData() {
    axios
      .post(baseUrl + "/api/sell-order-data", { search: "Sell", firstCoin: this.state.firstCoin, secondCoin: this.state.secondCoin })
      .then((res) => {
        this.setState({ records: res.data });
      })
      .catch();
  }

  editRecord(record) {
    this.setState({ currentRecord: record });
  }

  deleteRecordMgs = (record) => {
    confirmAlert({
      title: 'Confirm to submit',
      message: 'Really want to delete this pair?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => this.deleteRecord(record)
        },
        {
          label: 'No'
        }
      ]
    });
  }

  deleteRecord(record) {
    axios
      .post(baseUrl + "/v1/frontapi/delete-pending-order", { order_id: record.id, order_type: "sell", loginUserId: record.user_id })
      .then((res) => {
        if (res.status === 200) {
          toast(res.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          if (res.data.success) {
            window.location.reload();
          //  this.getData();
          }
        }
      })
      .catch();
   // this.getData();
  }

  pageChange(pageData) {
    console.log("OnPageChange", pageData);
  }

  supportClick = (e) => {
    var html = [];

    this.state.records.map((value) => {
      console.log("valuevaluevaluevalue", value);
      if (e.target.value == "pending") {
        if (value.status == "pending") {
          html.push(value);
        }
      }
      if (e.target.value == "completed") {
        if (value.status == "completed") {
          html.push(value);
        }
      }
      if (e.target.value == "deleted") {
        if (value.status == "deleted") {
          html.push(value);
        }
      }
      if (e.target.value == "edited") {
        if (value.status == "edited") {
          html.push(value);
        }
      }
      if (e.target.value == "select") {
        html.push(value);
      }
    });
    this.setState({ FilterRecords: html });
  };

  showFilterList = () => {
    const html = [];

    html.push(
      <select
        className="form-control"
        id="exchange"
        name="supportFilter"
        onClick={this.supportClick}
      >
        <option value="select" id="">
          Select Status
        </option>
        <option value="pending">Pending</option>
        <option value="edited">Edited</option>
        <option value="deleted">Deleted</option>
        <option value="completed">Completed</option>
      </select>
    );

    return <div className="support-select">{html}</div>;
  };

  getDateWiseData = (startdate, enddate) => {
    const inputDate = new Date(startdate);
    const day = inputDate.getDate();
    const month = inputDate.getMonth() + 1; // Months in JavaScript are 0-based
    const year = inputDate.getFullYear();
    const inputDate1 = new Date(enddate);
    const day1 = inputDate1.getDate();
    const month1 = inputDate1.getMonth() + 1; // Months in JavaScript are 0-based
    const year1 = inputDate1.getFullYear();
    const formattedDateE = `${year1}-${month1}-${day1}`;
    const formattedDateS = `${year}-${month}-${day}`;
    const data = {
      startDate: formattedDateS,
      endDate: formattedDateE,
    };
    axios
      .post(baseUrl + "/api/sell-order-data-by-date", data)
      .then((res) => {
        if (res.status === 200) {
          this.setState({ records: res.data });
        }
      })
      .catch((err) => {
        this.setState({ records: [] });
      });
  };
  render() {
    const selectionRange = {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    };
    return (
      <div>
        <Navbar />
        <div className="d-flex" id="wrapper">
          <Sidebar />

          <div id="page-content-wrapper">
            <div className="container-fluid">
              <button className="btn btn-link mt-3" id="menu-toggle">
                <FontAwesomeIcon icon={faList} />
              </button>

              <div className="row">
                <div className="col-md-5">
                  <h4 className="mt-2 man_hadding mb-3">Sell Order</h4>
                </div>
                <div className="col-md-4 text-right">
                  <div className="lsItem headerSearchItem ">
                    {/* <label>Check-in Date - Check-out Date</label> */}
                    <span style={{ height: "23px", width: "160px" }}
                      onClick={() => this.setState({ openActivityDateRange: !this.state.openActivityDateRange, })
                      }
                    >{(this.state.activityDateRange.length) ? `${format(this.state.activityDateRange[0].startDate, "MM/dd/yyyy")} to ${format(this.state.activityDateRange[0].endDate, "MM/dd/yyyy")}` : ""}</span>

                    {this.state.openActivityDateRange && (
                      <DateRange
                        onChange={(item) => {
                          this.setState({
                            activityDateRange: [item.selection],
                          });
                          this.getDateWiseData(
                            item.selection.startDate,
                            item.selection.endDate
                          );
                        }}
                        ranges={this.state.activityDateRange}
                      />
                    )}
                    <span
                      className="btn btn-primary"
                      onClick={() => {
                        this.setState({
                          openActivityDateRange:
                            !this.state.openActivityDateRange,
                        });
                      }}
                    >
                      Ok
                    </span>
                  </div>
                </div>
                <div className="col-md-3">{this.showFilterList()}</div>
              </div>
              <div className="white_box">
                <ReactDatatable
                  config={this.config}
                  records={
                    this.state.FilterRecords
                      ? this.state.FilterRecords
                      : this.state.records
                  }
                  columns={this.columns}
                  onPageChange={this.pageChange.bind(this)}
                />
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    );
  }
}

SellOrder.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  records: state.records,
});

export default connect(mapStateToProps)(SellOrder);
